<template>
  <div id="app" class="test">
    <router-view/>
  </div>
</template>

<script>
  // Vuex Store
  import store from './store/store'
  import { mapMutations, mapActions } from 'vuex'
  import { normaliseLangCode } from '../../shared/src/utils'

  export default {
    name: 'app',
    store,

    methods: {

      ...mapActions('config', ['getBrowser', 'validateApiGatewayData']),

      ...mapMutations('browser', {
        setBrowserName: 'setBrowserName',
        setBrowserVersion: 'setBrowserVersion'
      }),

      /**
       * @function to return the correct name of the users Browser (Opera thinks it is Chrome)
       * @returns {String} - The name of the user's Browser
       */
      browserName () {
        this.setBrowserName({browserName: this.config.user.browser.name})
      },

      /**
       * @function to return the correct version of the users Browser (Opera thinks it is Chrome)
       * @returns {Number} - The version number of the user's Browser
       */
      browserVersion () {
        this.setBrowserVersion({browserVersion: this.config.user.browser.versionNumber})
      },

      setLanguage () {
        this.$language.current = normaliseLangCode(this.config.troubleshooter.language)
      }
    },

    beforeCreate () {
      window.__APP_LOADED__ = true
    },

    created () {
      this.setLanguage()
      this.validateApiGatewayData()
        .then(() => {
          return this.getBrowser()
        })
        .then((browser) => {
          this.browserName()
          this.browserVersion()
        })
        .catch((err) => {
          return this.logError({'type': 'errors/cantFindBrowserError', 'payload': {'error': {'message': err.message}}})
        })
    }
  }
</script>

<style>


  .troubleshoot-main {
    background-color: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    box-shadow: 0px 0px 5px #CCCCCC;
    padding: 15px;
    overflow: hidden;
  }

  .troubleshoot-main header {
    border-bottom: 1px solid #CCCCCC;
  }

  .troubleshoot-main header h2 {
    margin: 20px;
    text-align: center;
  }

  p.explainer {
    margin: 20px 0;
    line-height: 1.7em;
  }

  #troubleshooterv3 p {
    font-size: 1.2em;
  }

  div.supported-browsers {
    border-top: 1px solid #CCC;
    overflow: hidden;
  }

  .pass, .fail {
    margin-top: 20px;
  }

  #troubleshooterv3 a.next-test {
    float: right;
    margin-top: 15px;
  }

  #troubleshooterv3 a.prev-test {
    float: left;
    margin-top: 15px;
  }

  #troubleshooterv3 a.next-dash {
    float: right;
    margin-top: 15px;
  }

  .move-on {
    border-top: 1px solid #CCCCCC;
    overflow: hidden;
    margin-top: 15px;
  }

  h2.test-passed {
    border-radius: 4px;
    text-align: center;
    padding: 15px;
  }

  div#preview-video {
    text-align: center;
  }

  canvas#preview-audio {
    display: block;
    margin: auto;
    height: 50px;
    width: 320px;
    border: 1px solid #CCC;
    margin-bottom: 20px;
    border-radius: 4px;
  }

  .browser-name, .browser-version, .browser-os, .browser-platform {
    font-weight: bold;
  }

  #troubleshooterv3 .chosen-container {
    display: none;
  }

  .select-media {
    margin-bottom: 20px;
  }

  #troubleshooterv3 ul {
    text-align: left;
  }

  .skip {
    border: 1px solid #CCCCCC;
    margin-top: 15px;
    overflow: hidden;
    padding: 15px;
    border-radius: 4px;
    background-color: #efefef;
    font-size: .8em;
  }

  .skip-note {
    margin-bottom: 0;
  }

</style>
